export default __webpack_public_path__ + "static/media/event-1.ec62c447.JPG";